import { ResponsiveContainer, AreaChart, Area, YAxis } from "recharts";

export default function Sparkline({
    data,
    height = 44,
    color = "#22C55E",
    fillOpacity = 0.18,
    dataKey = "value",
}) {
    if (!data || data.length === 0) return null;
    return (
        <div style={{ width: "100%", height }}>
            <ResponsiveContainer>
                <AreaChart data={data} margin={{ top: 2, right: 2, bottom: 2, left: 2 }}>
                    <defs>
                        <linearGradient id={`spark-${color}`} x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor={color} stopOpacity={fillOpacity} />
                            <stop offset="100%" stopColor={color} stopOpacity={0} />
                        </linearGradient>
                    </defs>
                    <YAxis hide domain={["dataMin", "dataMax"]} />
                    <Area
                        type="monotone"
                        dataKey={dataKey}
                        stroke={color}
                        strokeWidth={1.5}
                        fill={`url(#spark-${color})`}
                        isAnimationActive={false}
                    />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    );
}
